import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from './modules/auth'
import dummy from './modules/dummy'
import middleware from './middleware'
import getDataFromStorage from '@/helpers/getDataFromStorage'
import pendidikan from './modules/pendidikan'
import member from './modules/member'
import mentorship from './modules/mentorship'
import platform from './modules/platform'
import master from './modules/master'
import user from './modules/user'


const { tokenCurrent } = getDataFromStorage()

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...dummy,
    ...auth,
    ...pendidikan,
    ...member,
    ...mentorship,
    ...platform,
    ...master,
    ...user,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const context = {
      to, from, next,
    }
    const middlewareOfMeta = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]
    return middleware(context, middlewareOfMeta)
  }

  if (to.meta.authenticationPage && tokenCurrent) {
    return next('/')
  }

  return next()
})
// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
